import {
  EmptyState,
  EmptyStateDecoration,
  EmptyStateDescription,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { Spinner } from '@/components/Spinner'

export function OCRScopeJobScopingInProgress() {
  return (
    <EmptyState size="sm">
      <EmptyStateDecoration>
        <Spinner size={80} thickness={4} />
      </EmptyStateDecoration>
      <EmptyStateTitle>OCR is processing</EmptyStateTitle>
      <EmptyStateDescription>
        Please check back again in a few minutes.
      </EmptyStateDescription>
    </EmptyState>
  )
}
